module.exports = __webpack_public_path__ + "images/eggplant_web-744be578f6e0fa96bd665edf4fc284d7.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/eggplant_web.svg
// module id = 211
// module chunks = 0